var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dept-tips"},[(['010405', '0110C', '0110H', '0110D', '0110E', '0110F', '0110G', '01076','012F01','012F02'].includes(_vm.item.deptCode))?[_vm._v(" "+_vm._s(_vm._f("nameTips")(_vm.item.doctorName))+" ")]:[_vm._v(" "+_vm._s(_vm._f("tips")(_vm.item.deptCode))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }